<template>
  <div class="how-it-works">
    <Navbar />
    <div class="my-5 pb-4"></div>
    <div class="container py-5">
      <div class="row pb-5">
        <div class="col-12 col-md-6 col-lg-4 text-left pb-5">
          <h3 class="font-weight-bolder text-capitalize kova-text">
            How can we help
          </h3>
          <h5 class="font-weight-bolder kova-text">What Task Can I Do?</h5>
          <p class="pt-2 pb-4 ">
            TalentAlt has got you covered on the software development skill that
            you possess based on your speciality.
          </p>
          <p class="">
            There’s a wide range of job offers that spans across Web
            applications, Product Management, Data Engineering and a host of
            others. With multiple services on software development that makes
            your talent fit in and get highly demanded for, be rest assured that
            you can secure jobs that are ideal for you as a remote developer.
          </p>
          <div class="d-flex ml-4 mt-4">
            <div class="">
              <router-link to="/how-it-works">
                <button
                  class="btn-outline-kovatek ctrl-size py-2 mr-3"
                  style="width: 150px"
                >
                  Hiring Talents
                </button>
              </router-link>
            </div>
            <div class="">
              <router-link to="/dev-how-it-works">
                <button class="btn-kovatek ctrl-size py-2" style="width: 150px">
                  Working as Talent
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-8 text-left pb-5">
          <div class="hiw-home">
            <div class="hiw-home-img-1"></div>
            <div class="hiw-home-img-2"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid kova-bg py-5">
      <div class="container px-md-5">
        <div class="px-lg-5">
          <!-- <h6 class="font-weight-bolder text-capitalize text-white pb-3">
                        As a developer on TalentAlt you have access to different jobs that require your skill set, TalentAlt fast tracks you to numerous offers  on our list of available jobs, you make the choice on which to work for by sending your proposals to your preferred job offer.
                    </h6> -->
          <p class="pb-3 text-white">
            On TalentAlt, developers can work either full-time or part-time with
            secured means of payment based on the price agreed by both parties.
            Developers are also open to expanding their skills and portfolio and
            gaining experience by working with potential founders with beautiful
            ideas. Developers on the platform are part of various product
            building teams that will build globally impacting products. All that
            needs to be done is for you to complete your vetting exercise to
            enable you to get connected with jobs.
          </p>
          <router-link to="/devsignup">
            <button class="btn-transparent-kovatek ctrl-size py-2 px-3">
              Work as a Talent
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="container-fluid py-5">
      <div class="container">
        <h5 class="font-weight-bolder text-uppercase kova-text pt-4 pb-5">
          how to get started
        </h5>
        <div class="row pb-5">
          <div class="col-12 col-md-6 text-left">
            <div class="py-4">
              <ul class="StepProgress">
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder kova-text">
                      Get approved as a developer on TalentAlt
                    </h6>
                    <p class="kova-text font-weight-bolder">
                      To do this simply:
                    </p>
                    <ul>
                      <li class="">
                        Provide information on your skill and career as a
                        developer
                      </li>
                      <li class="">
                        Upload a professional profile photo
                      </li>
                      <li class="">
                        Provide means of receiving payment
                      </li>
                      <li class="">
                        Undergo a vetting process
                      </li>
                    </ul>
                    <p class="kova-text font-weight-bolder mt-4">
                      The three vetting process:
                    </p>
                    <ul>
                      <li class="">
                        Tell us about yourself and your skills as a developer
                      </li>
                      <li class="">Undergo a sprint project exercise</li>
                      <li class="">Live interview with an expert.</li>
                    </ul>
                    <p class="mt-3">
                      These three processes will be used to determine your skill
                      depth and level of expertise to match you with jobs that
                      best fit and are suitable for you based on the outcome of
                      the vetting exercise and your level of expertise.
                    </p>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder kova-text">
                      Browse through Jobs
                    </h6>
                    <p class="">
                      After you have successfully been vetted, you are now on
                      the platform as a developer and can search and browse
                      through jobs based on requirements that match your
                      skill-set, area of specialisation, expertise, price range
                      and duration.
                    </p>
                    <p class="">
                      You can also make general searches for available jobs with
                      skills that you possess, save jobs and also get notified
                      when jobs that match your skill-set are available.
                    </p>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder kova-text">
                      Write a great proposal
                    </h6>
                    <p class="">
                      Once you have seen jobs that you would love to take on,
                      you will have to write a proposal that reflects an
                      understanding of your client’s briefs and needs. Your
                      proposals should indicate to your client how you will help
                      deliver what they want and that you are the best person
                      for the job based on your skill, expertise and experience.
                      Your proposal is your means to convince your client that
                      you can deliver.
                    </p>
                    <p class="">
                      As a talent that is available for full-time remote jobs
                      with global companies, you can simply apply for jobs
                      posted by organizations looking for remote talent to join
                      their team of developers. The hiring manager would be able
                      to access your TalentAlt profile, skill vetting details
                      and interview you for the job role.
                    </p>
                  </div>
                </li>
                <li class="StepProgress-item numbered current">
                  <div class="pt-1 pb-4">
                    <h6 class="font-weight-bolder kova-text">
                      Get the job, work and earn
                    </h6>
                    <p class="">
                      When you get a job or your proposal lands you the job
                      (REPETITIVE), deliver outstanding service that gets
                      approval from your client and get paid appropriately.+
                    </p>
                  </div>
                </li>
                <li class="StepProgress-item"></li>
                <div class="ml-5">
                  <router-link to="/jobs">
                    <button class="btn-kovatek py-2 px-3 ml-5">
                      Browse Jobs
                    </button>
                  </router-link>
                </div>
              </ul>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="vp-middle bg-light">
              <div class="mb-5">
                <div class="green-rounded-1"></div>
                <div class="hiw-steps-img-1 mt-5"></div>
                <!-- <div class="path-1"></div> -->
              </div>
              <div class="">
                <div class="green-rounded-2"></div>
                <div class="hiw-steps-img-2 mt-5"></div>
                <!-- <div class="path-2"></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid kova-bg">
      <div class="container py-5">
        <div class="row text-white">
          <div class="col-12 col-md-6 text-left pb-5">
            <h3 class="font-weight-bolder text-capitalize text-white">
              Manage Your Career On The Go
            </h3>
            <p class="">
              You don’t need to be on the platform 24/7. You can stay in contact
              with clients, collaborate with them and get notified of new jobs,
              messages from clients and the likes through our mobile application
              and desktop platform. TalentAlt helps you monitor activities on
              the platform that interests you.
            </p>
          </div>
          <div class="col-12 col-md-6 pb-5">
            <div class="hiw-phone">
              <!-- <div class="green-circle"></div> -->
              <!-- <div class="blue-circle"></div> -->
              <div class="hiw-phone-img"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container py-5 mt-5">
        <div class="row pb-5 text-white flex-row-reverse">
          <div class="col-12 col-md-6 text-left pb-5">
            <h3 class="font-weight-bolder text-capitalize text-white">
              Secure, Easy And Safe
            </h3>
            <p class="">
              TalentAlt ensures that your payments and activities are secured.
              We make security top priority and it is very crucial for us to
              protect what you’ve worked for: Career, Money, Reputation and
              Experience.
            </p>
            <ul class="">
              <li class="">We make sure all transactions are secured</li>
              <p class="">
                All transactions done on the platform which includes your
                payment for job done are highly protected and flows seamlessly
                with ease.
              </p>
              <li class="">You get paid through a milestone agreement</li>
              <li class="">
                Our support team is available to assist and guide you.
              </li>
            </ul>
            <p class="">
              We work as a community to ensure growth, support and assistance
            </p>
          </div>
          <div class="col-12 col-md-6 text-left pb-5">
            <div class="hiw-lock">
              <div class="blue-rounded"></div>
              <div class="hiw-ellipse-img"></div>
              <div class="hiw-lock-img"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <GetHired />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import GetHired from '@/components/GetHired.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'how-it-works',
  components: {
    Navbar,
    Footer,
    GetHired,
  },
  data() {
    return {
      current: 0,
    };
  },
  methods: {
    onChange(current) {
      // console.log('onChange:', current);
      this.current = current;
    },
  },
};
</script>

<style scoped>
p,
li,
.ctrl-size {
  font-size: 12px;
}
.vp-head {
  text-shadow: -1px 0 #20409a, 0 1px #20409a, 1px 0 #20409a, 0 -1px #20409a,
    -1px -1px #20409a, 1px 1px #20409a, -1px 1px #20409a, 1px -1px #20409a;
}
.it-works-btn {
  border: 0;
  outline: 0;
  height: 35px;
  width: 135px;
  font-size: 12px;
  color: #fff;
  border-radius: 5px;
}
.hiw-home {
  height: 340px;
}
.hiw-home-img-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-013.png');
  left: 100px;
  top: 15px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 420px;
  height: 300px;
}
.hiw-home-img-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-014.png');
  left: 385px;
  top: 45px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 320px;
  height: 240px;
}
.hiw-second {
  background-color: #c0e4d8;
}
.wrapper {
  width: 330px;
  font-family: 'Helvetica';
  font-size: 14px;
  border: 1px solid #ccc;
}
.StepProgress {
  position: relative;
  padding-left: 45px;
  list-style: none;
}
.StepProgress::before {
  display: inline-block;
  content: '';
  position: absolute;
  top: 0;
  left: 15px;
  width: 10px;
  height: 100%;
  border-left: 0px solid #ccc;
}
.StepProgress-item {
  position: relative;
}
.numbered {
  counter-increment: list;
}
.StepProgress-item:not(:last-child) {
  padding-bottom: 20px;
}
.StepProgress-item::before {
  display: inline-block;
  content: '';
  position: absolute;
  left: -15px;
  height: 100%;
  width: 10px;
}
.StepProgress-item::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  left: -37px;
  width: 50px;
  height: 50px;
  border: 2px solid #ccc;
  border-radius: 50%;
  background-color: #20409a;
}
.StepProgress-item.is-done::before {
  border-left: 1.5px solid #fff;
}
.StepProgress-item.is-done::after {
  content: '✔';
  font-size: 20px;
  padding-top: 10px;
  color: #fff;
  text-align: center;
  border: 1px solid #20409a;
  background-color: #20409a;
}
.StepProgress-item.current::before {
  border-left: 1.5px solid #20409a;
}
.StepProgress-item.current::after {
  content: '0' counter(list);
  padding-top: 10px;
  width: 50px;
  height: 50px;
  top: -4px;
  left: -40px;
  font-size: 20px;
  text-align: center;
  color: #fff;
  border: 1px solid #20409a;
  background-color: #20409a;
}
.StepProgress-item > div {
  margin-left: 50px;
}
.vp-middle {
  height: 650px;
  margin: 0 10px 0 40px;
}
.hiw-steps-img-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-018.png');
  left: 100px;
  top: 40px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 400px;
  height: 260px;
}
.hiw-steps-img-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-019.png');
  left: 100px;
  top: 350px;
  z-index: 2;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 400px;
  height: 260px;
}
.green-rounded-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-015.png');
  left: 390px;
  top: 170px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 85px;
}
.green-rounded-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-016.png');
  left: 0;
  top: 480px;
  z-index: 4;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 85px;
}
.path-1 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/path-001.png');
  left: 520px;
  top: 310px;
  z-index: 6;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 49px;
  height: 150px;
}
.path-2 {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/path-002.png');
  left: 40px;
  top: 560px;
  z-index: 6;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 49px;
  height: 150px;
}
.hiw-phone {
  height: 200px;
}
.green-circle {
  position: absolute;
  top: 10px;
  left: 80px;
  height: 240px;
  width: 230px;
  background-color: #66d162;
  border-radius: 50%;
}
.blue-circle {
  position: absolute;
  top: 360px;
  left: 320px;
  height: 130px;
  width: 130px;
  background-color: #5087ef;
  border-radius: 50%;
}
.hiw-phone-img {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/image-017.png');
  left: 100px;
  top: 0px;
  z-index: 6;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 330px;
  height: 265px;
}
.hiw-lock {
  height: 240px;
}
.blue-rounded {
  position: absolute;
  left: 110px;
  width: 220px;
  height: 220px;
  z-index: 6;
  border: solid 5px #fff;
  border-radius: 50%;
}
.hiw-ellipse-img {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/ellipse-02.png');
  left: 120px;
  top: 15px;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 220px;
  height: 220px;
}
.hiw-lock-img {
  position: absolute;
  background-image: url('../assets/KOVATEK/IMAGES/lock-white.png');
  left: 180px;
  top: 40px;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 90px;
  height: 120px;
}

@media screen and (max-width: 1236px) {
  .hiw-home-img-1 {
    left: 100px;
    width: 320px;
    height: 270px;
  }
  .hiw-home-img-2 {
    left: 330px;
    top: 50px;
    width: 250px;
    height: 180px;
  }
  .hiw-steps-img-1 {
    left: 70px;
    top: 40px;
    width: 320px;
    height: 210px;
  }

  .hiw-steps-img-2 {
    left: 70px;
    top: 310px;
    width: 320px;
    height: 100px;
  }
  .hiw-steps-img-3 {
    left: 70px;
    top: 470px;
    width: 320px;
    height: 210px;
  }
  .green-rounded-1 {
    left: 270px;
    top: 150px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-2 {
    left: 0;
    top: 420px;
    width: 220px;
    height: 85px;
  }
}

@media screen and (max-width: 991px) {
  .hiw-home-img-1 {
    left: 10px;
    width: 250px;
    height: 240px;
  }
  .hiw-home-img-2 {
    left: 140px;
    top: 40px;
    width: 240px;
    height: 160px;
  }
  .hiw-steps-img-1 {
    left: 20px;
    top: 40px;
    width: 320px;
    height: 210px;
  }

  .hiw-steps-img-2 {
    left: 20px;
    top: 310px;
    width: 320px;
    height: 100px;
  }
  .green-rounded-1 {
    left: 180px;
    top: 170px;
    width: 220px;
    height: 85px;
  }
  .hiw-phone-img {
    left: 50px;
    top: 30px;
    width: 280px;
    height: 220px;
  }
}

@media screen and (max-width: 768px) {
  .hiw-home {
    height: 280px;
  }
  .hiw-home-img-1 {
    left: 20px;
    width: 300px;
    height: 250px;
    /* left: 0;
        right:0;
        margin-right: auto;
        margin-left: auto; */
  }
  .vp-middle {
    height: 500px;
    margin: 0 10px 0 10px;
  }
  .hiw-home-img-2 {
    left: 220px;
    top: 60px;
    width: 240px;
    height: 160px;
  }
  .hiw-steps-img-1 {
    left: 80px;
    top: 40px;
    width: 320px;
    height: 210px;
  }
  .hiw-steps-img-2 {
    left: 80px;
    top: 310px;
    width: 320px;
    height: 100px;
  }
  .green-rounded-1 {
    left: 270px;
    top: 150px;
    width: 220px;
    height: 85px;
  }
  .green-rounded-2 {
    left: 0;
    top: 420px;
    width: 220px;
    height: 85px;
  }
  .hiw-phone {
    height: 340px;
  }
  .hiw-phone-img {
    left: 100px;
    top: 30px;
    width: 230px;
    height: 385px;
  }
  .blue-rounded {
    left: 120px;
    width: 200px;
    height: 200px;
  }
  .hiw-lock {
    height: 200px;
  }
  .hiw-ellipse-img {
    left: 130px;
    top: 15px;
    width: 200px;
    height: 200px;
  }
  .hiw-lock-img {
    left: 175px;
    top: 35px;
    width: 90px;
    height: 120px;
  }
}

@media screen and (max-width: 520px) {
  .hiw-home {
    height: 150px;
  }
  .hiw-home-img-1 {
    left: 20px;
    width: 200px;
    height: 170px;
  }
  .vp-middle {
    height: 350px;
  }
  .hiw-home-img-2 {
    left: 135px;
    top: 30px;
    width: 190px;
    height: 140px;
  }
  .hiw-steps-img-1 {
    left: 37px;
    top: 20px;
    width: 250px;
    height: 160px;
  }
  .hiw-steps-img-2 {
    left: 37px;
    top: 220px;
    width: 250px;
    height: 75px;
  }
  .green-rounded-1 {
    left: 120px;
    top: 120px;
  }
  .green-rounded-2 {
    left: -25px;
    top: 310px;
  }
  .hiw-phone {
    height: 300px;
  }
  .hiw-phone-img {
    left: 50px;
  }
  .blue-rounded {
    left: 70px;
    width: 200px;
    height: 200px;
  }
  .hiw-lock {
    height: 120px;
  }
  .hiw-ellipse-img {
    left: 85px;
  }
  .hiw-lock-img {
    left: 125px;
  }
}
</style>
